import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { addrecordedLessons, getrecordedLessons, isImageOpenModal, isOpenModal, ModalToggle, statusDeleterecordedLessons, updaterecordedLessons, updateRecordedLessonsVideo, } from '../../store/recordedLessonsSlice';
import Dropzone from 'react-dropzone-uploader';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const RecordedLessonsTable = () => {
  const storeVar = useSelector(state => state.recordedLessons)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { layoutURL } = useContext(CustomizerContext);
  const toggle = () => dispatch(ModalToggle());
  const Imagetoggle = () => dispatch(isImageOpenModal());

  const [mainId, setmainId] = useState()
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    modalTitle: null,
    editState: false,
    lessonId: '',
    title: '',
    videoPrice: '',
    testPrice: '',
    content: '',
    bannerFile: null,
    bannerImageURL: null,
    videoUrl: '',
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setmainId(id);

    dispatch(getrecordedLessons(formVar.limit, formVar.offset, id))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getrecordedLessons(formVar.limit, offset, mainId))
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      modalTitle: 'Edit Lesson',
      lessonId: data._id,
      title: data.title,
      videoPrice: data.videoPrice,
      testPrice: data.testPrice,
      content: data.content,
      videoUrl: data.videoUrl || ''
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Lesson',
      title: '',
      lessonId: '',
      videoPrice: '',
      testPrice: '',
      content: '',
      videoUrl: '',
    }))
  }


  const submitMenu = () => {
    if (titleValid() || contentValid() || videoUrlValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updaterecordedLessons(formVar.lessonId, { title: formVar.title, videoPrice: formVar.videoPrice, testPrice: formVar.testPrice, content: formVar.content, videoUrl: formVar.videoUrl }))
    } else {
      dispatch(addrecordedLessons({ chapterId: mainId, title: formVar.title, videoPrice: formVar.videoPrice, testPrice: formVar.testPrice, content: formVar.content, videoUrl: formVar.videoUrl }))
    }
  }


  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }
  const lessonPriceValid = () => {
    if (!formVar.videoPrice) {
      return "Video Price is required";
    }
  }
  const testPriceValid = () => {
    if (!formVar.testPrice) {
      return "Test Price is required";
    }
  }
  const contentValid = () => {
    if (!formVar.content) {
      return "Content is required";
    }
  }
  const videoUrlValid = () => {
    if (!formVar.videoUrl) {
      return "YouTube URL is required";
    }
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(statusDeleterecordedLessons(data._id))
        }
      });
  }

  const onNavigate = (data) => {
    navigate('/recorded-questions/' + layoutURL + '?id=' + data._id)
  }

  const ImageEditBannerModal = (data) => {
    dispatch(isImageOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      lessonId: data._id,
      modalTitle: 'Update Video',
      bannerFile: null,
      bannerImageURL: null
    }))
  }

  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'done') {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormVar((prevFormVar) => ({
          ...prevFormVar,
          bannerImageURL: e.target.result,
        }))
      };
      reader.readAsDataURL(file);
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: file,
      }))
    } else if (status === "removed") {
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: null,
        bannerImageURL: null,
      }))
    }
  };
  const filesValid = () => {
    if (!formVar.bannerFile) {
      return "Files is required";
    }
  }
  const submitImage = () => {
    if (filesValid()) {
      setSubmit(true)
      return null
    }

    setSubmit(false)
    dispatch(updateRecordedLessonsVideo(formVar.lessonId, formVar.bannerFile))
  }



  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
              </Col>
              <Col md="4">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Lessons
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Questions</th>
                  <th scope='col'>Video Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.recordedLessonsData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.title}</td>
                    <td >{item.questions.length}</td>
                    <td>
                      {
                        (item.videoUrl) && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Active</span>
                          </span>
                        </>
                      }
                      {
                        !(item.videoUrl) && <>
                          <span className={`font-warning w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Pending</span>
                          </span>
                        </>
                      }
                    </td>

                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        {/* <div className='cursor-pointer font-success action-icon'>
                          <i className="fa fa-picture-o fa-lg" onClick={(e) => ImageEditBannerModal(item)} />
                          <div className="tooltipCustom">Update Video</div>
                        </div> */}
                        <div className='cursor-pointer bg-light-primary font-info action-icon'>
                          <i className="fa fa-book fa-lg" onClick={() => onNavigate(item)}></i>
                          <div className="tooltipCustom">Questions</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalrecordedLessons <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalrecordedLessons > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalrecordedLessons}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} size={'lg'}>
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder='Enter Title' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
            <Row>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Lesson Price</Label>
                <Input className="form-control" type="text" placeholder='Enter Lesson Price (0 For Free)' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, videoPrice: e.target.value }))} value={formVar.videoPrice} />
                {submit && lessonPriceValid() ? <span className='d-block font-danger'>{lessonPriceValid()}</span> : ""}
              </Col>
              <Col md={6}>
                <Label className="col-form-label" for="recipient-name">Test Price</Label>
                <Input className="form-control" type="text" placeholder='Enter Test Price (0 For Free)' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, testPrice: e.target.value }))} value={formVar.testPrice} />
                {submit && testPriceValid() ? <span className='d-block font-danger'>{testPriceValid()}</span> : ""}
              </Col>
            </Row>
            <Label className="col-form-label" for="recipient-name">Content</Label>
            <textarea className="form-control" rows={5} type="text" placeholder='Enter Content' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, content: e.target.value }))} value={formVar.content} />
            {submit && contentValid() ? <span className='d-block font-danger'>{contentValid()}</span> : ""}
            <Label className="col-form-label" for="video-url">YouTube URL</Label>
            <Input className="form-control" type="text" placeholder='Enter YouTube URL' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, videoUrl: e.target.value }))} value={formVar.videoUrl} />
            {submit && videoUrlValid() ? <span className='d-block font-danger'>{videoUrlValid()}</span> : ""}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isImageOpenModal} title={formVar.modalTitle} toggler={Imagetoggle} >
        <Form>
          <FormGroup>
            {
              formVar.bannerImageURL && <>
                <div className='d-flex justify-content-center h-10-r'>
                  <img className=' h-100' src={formVar.bannerImageURL} alt="" />
                </div>
              </>
            }
            <Label className="col-form-label" for="recipient-name">Update Video</Label>
            <Dropzone
              className='dropzone dz-clickable'
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              // canCancel={false}
              accept="video/*"
              inputContent='Drop A File'
              styles={{
                dropzone: { width: '100%', height: 150 },
                dropzoneActive: { borderColor: 'green' },
              }}
            />
            {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: Imagetoggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitImage }}>Save Changes</Btn>

        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default RecordedLessonsTable;
